import axios from "axios";
import _, { get } from "lodash";
import React from "react";
import { BASE_URL } from "../../../consts/app.consts";
import { BadgeCell, DefaultCell, ResourcePersonCell } from "./components/cells";
import * as Yup from 'yup';
import { printAction } from "../../../actions";
import { PRINT } from "../../../consts/methods.consts";

const ModulePlanAmendmentConfig = {
  searchApi: "xceed.api.report.amendment_request.generate_amendment_request_report",
  alert:
    "Reminder: Specify a date range to receive reports. Use other fields to further narrow down data within the required date range.",
  excelFileName: "resource-person-report",
  title: "Module Plan Amendment Request Report",
  extraActionsAsMenu: true,
  sections: [
    {
      selectionTitle: "Date Range",
      grid: { base: 1, md: 2, lg: 4, xl: 4 },
      filters: [
        {
          is_required: true,
          label: "From",
          type: "date",
          key: "from",
          validationSchema: Yup.string().required('From date is required')
        },
        {
          is_required: true,
          label: "To",
          type: "date",
          key: "to",
          validationSchema: Yup.string().required('To date is required')
        },
      ],
    },
    {
      selectionTitle: "Filters",
      grid: { base: 1, md: 2, lg: 4, xl: 4 },
      filters: [
        {
          is_required: true,
          label: "Module Coordinator",
          key: "mc",
          type: "form-select",
          optionMethod: "xceed.api.report.amendment_request.get_mc_list",
          validationSchema: Yup.string().required('Module coordinator is required')
        },
      ],
    },
  ],

  tableConfig: {
    column: [
      {
        header: "Module plan Name",
        accessor: "module",
        width: 300,
      },
      {
        header: "module completed ",
        accessor: "completed",
        width: 200,
        customRenderer: (value: any, item: any) =>
          React.createElement(BadgeCell, {
            config: statusBadgeConfig,
            value: value,
          }),
      },
      {
        header: "Module end date",
        accessor: "end_date",
        width: 200,
      },
      {
        header: "Assigned date to Registrar",
        accessor: "assigned_date_to_registrar",
        width: 200,
      },
      {
        header: "Assigned date to officer",
        accessor: "assigned_date_to_officer",
        width: 200,
      },
      {
        header: "No of days pending with officer",
        accessor: "no_of_days_pending_with_officer",
        width: 200,
      },
    ],
  },
  actions: [
    {
      text: "Generate Bulk Report",
      onClick: async (filter: any, data: any, setLoading: any) => {
        if (filter.to && filter.from) {
          setLoading(true);
          try {
            await printAction(PRINT.PRINT_AMENDMENT_REQUEST_BULK_REPORT, { filter }, setLoading);
          } catch (error: any) {
            setLoading(false);
            const newError: any = new Error("Unable to print report");
            newError.title = "Error";
            newError.status = "error";
            throw newError;
          }
        } else {
          const error: any = new Error(
            "Please select from date, to date "
          );
          error.title = "Warning";
          error.status = "warning";
          throw error;
        }
      },
      buttonVariant: "solid",
      buttonColorScheme: "teal",
    },
    {
      text: "Generate Report",
      onClick: async (filter: any, data: any, setLoading: any) => {
        if (filter.to && filter.from && filter.mc) {
          setLoading(true);
          try {
            await printAction(PRINT.PRINT_AMENDMENT_REQUEST_MC_WISE_REPORT, { filter }, setLoading);
          } catch (error: any) {
            setLoading(false);
            const newError: any = new Error("Unable to print report");
            newError.title = "Error";
            newError.status = "error";
            throw newError;
          }
        } else {
          const error: any = new Error(
            "Please select from date, to date and module coordinator "
          );
          error.title = "Warning";
          error.status = "warning";
          throw error;
        }
      },
      buttonVariant: "solid",
      buttonColorScheme: "teal",
    },
  ],
};

export default ModulePlanAmendmentConfig;

const statusBadgeConfig = {
  No: "bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
  Yes: "bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded",
};
